'use strict';/*jslint ts:true, react:true*/
import React, {CSSProperties, useContext, useRef} from 'react';
import cn from 'classnames';
import {Editor} from '../../../shared/editor/editor';
import {Settings_context} from '../settings_ctx';
import {use_screen} from '../lib/screen_util';
import {Button} from '../../../shared/button';
import {use_download} from '../shared/use_download';
import {img_url} from '../ui/img_url';
import Chevron_left from '../img/hola2023/icons/16/chevron_left.svg';
import Chevron_right from '../img/hola2023/icons/16/chevron_right.svg';
import {App_context} from 'hola_app_context';
import styles from './popular_games_banner.module.less';

const games = [
    {game: 'Minecraft', img: img_url('popular_games/minecraft.png')},
    {game: 'Fortnite', img: img_url('popular_games/fortnite.png')},
    {game: 'Roblox', img: img_url('popular_games/roblox.png')},
    {game: 'Counter-Strike 2', img: img_url('popular_games/cs_2.png')},
    {game: 'League of Legends',
        img: img_url('popular_games/league_of_legends.png')},
    {game: 'Valorant', img: img_url('popular_games/valorant.png')},
    {game: 'Dota 2', img: img_url('popular_games/dota_2.png')},
    {game: 'Call of Duty: Warzone',
        img: img_url('popular_games/cod_warzone.png')},
    {game: 'Grand Theft Auto V', img: img_url('popular_games/gta_v.png')},
    {game: 'The Sims 4', img: img_url('popular_games/the_sims_4.png')},
    {game: 'Apex Legends', img: img_url('popular_games/apex_legends.png')},
    {game: 'PUBG: Battlegrounds',
        img: img_url('popular_games/pubg_battlegrounds.png')},
    {game: 'Rainbow Six Siege',
        img: img_url('popular_games/rainbow_six_siege.png')},
    {game: 'Rocket League', img: img_url('popular_games/rocket_league.png')},
    {game: 'Overwatch 2', img: img_url('popular_games/overwatch_2.png')},
    {game: 'EA Sports FC 25', img: img_url('popular_games/fc_25.png')},
    {game: 'Destiny 2', img: img_url('popular_games/destiny_2.png')},
    {game: 'Genshin Impact', img: img_url('popular_games/genshin_impact.png')},
    {game: 'War Thunder', img: img_url('popular_games/war_thunder.png')},
    {game: 'Team Fortress 2',
        img: img_url('popular_games/team_fortress_2.png')},
];

interface i_popular_games_banner_props {
    title: string;
    button_text: string;
    download_type?: string;
}

export const Popular_games_banner = (
props: i_popular_games_banner_props)=>{
    const {title, button_text, download_type = 'gameboost'} = props;
    const {theme} = useContext(Settings_context);
    const {is_client} = useContext(App_context);
    const {screen, width} = use_screen();
    const is_mobile = screen=='xs' || screen=='sm';
    const {download, download_gameboost} = use_download();
    const on_download = ()=>{
        if (download_type=='gameboost')
            return void download_gameboost();
        download();
    };
    const container_ref = useRef<HTMLDivElement>(null);
    const scroll_amount = 120 + 16;
    const scroll_left = ()=>{
        const container = container_ref.current;
        if (!container)
          return;
        if (container.scrollLeft == 0)
          container.scrollLeft = container.scrollWidth;
        container.scrollBy({left: -scroll_amount, behavior: 'smooth'});
    };
    const scroll_right = ()=>{
        const container = container_ref.current;
        if (!container)
          return;
        const scroll_width = container.scrollWidth - 16;
        if (container.scrollLeft + container.offsetWidth >= scroll_width)
          container.scrollLeft = 0;
        container.scrollBy({left: scroll_amount, behavior: 'smooth'});
    };
    const items = is_client && width > 768
        ? [...games, ...games] : games;
    const grid_cols = {
        '--grid_cols': items.length
            ? Array(items.length).fill('auto').join(' ') : 'auto'
    } as CSSProperties;
    return <div className={styles.wrapper}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.carousel_wrapper}>
        <div className={styles.fade_left}>
          <button onClick={scroll_left}
            className={styles.nav_btn}><Chevron_left /></button>
        </div>
        <div className={styles.cards} ref={container_ref} style={grid_cols}>
          {items.map(({game, img}, i)=>
            <div key={i} className={styles.card}>
              <img className={cn('lazyload', styles.card_img)}
                src={img} alt={game} />
              <p className={cn([theme.p4, theme.med, theme.color_n600])}>
                {game}</p>
            </div>
          )}
        </div>
        <div className={styles.fade_right}>
          <button onClick={scroll_right}
            className={styles.nav_btn}><Chevron_right /></button>
        </div>
      </div>
      <div className={styles.cta}>
        <Button on_click={on_download} caption={button_text}
          color="black2023" size={is_mobile ? 'md' : 'lg'} round />
      </div>
    </div>;
};

interface i_popular_games_banner_editor_props {
    value: i_popular_games_banner_props;
    on_change: (new_val: i_popular_games_banner_props)=>void;
}

export const Popular_games_banner_editor = (
{value, on_change}: i_popular_games_banner_editor_props)=>{
    return <Editor value={value} on_change={on_change}
      editors={[
        {key: 'title', label: 'Title', type: 'text'},
        {key: 'button_text', label: 'Button text', type: 'text'},
        {key: 'download_type', label: 'Download type (gameboost / vpn)',
          type: 'text'},
      ]}/>;
};
